// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_RbeZO","icon":"index_icon_202ZE","setIcon":"index_setIcon_2s1Mk","setIconActive":"index_setIconActive_3v0Bs","link":"index_link_1ZwqR"};